///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.recaptcha = abcsetup.recaptcha || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.recaptcha.action = null;




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.recaptcha = {
    init: function(action = null) {
        /*
        // Implement v2 of reCAPTCHA
        $('form').each(function() {
            $(this).append('<div class="g-recaptcha" data-sitekey="' + abcsetup.recaptchaSiteKey + '"></div>');
            $(this).find(':input[type="submit"]').prop('disabled', true).addClass('disabled');
        });
        */

        abcsetup.recaptcha.action = action || abcsetup.page_name;

        // Implment v3 of reCAPTCHA
        if (window.grecaptcha === undefined) {
            var script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js?render=" + abcsetup.recaptchaSiteKey;

            script.addEventListener('load', function() {
                grecaptcha.ready(function() {
                    abcsetup.recaptcha.generate();
                });
            });
            
            document.getElementsByTagName("body")[0].appendChild(script);

        // window.grecaptcha is already defined, just generate the reCAPTCHA token
        } else {
            abcsetup.recaptcha.generate();
        }

        // Auto re-gen the token every min
        setInterval(function() {
            abcsetup.recaptcha.generate();
        }, 60 * 1000)
    },


    /**
     * Generate the actual reCAPTCHA token
     */
    generate: function() {
        // generate function called without calling init first
        if (!abcsetup.recaptcha.action || window.grecaptcha === undefined) {
            return false;
        }

        grecaptcha.execute(abcsetup.recaptchaSiteKey, {action: abcsetup.recaptcha.action}).then(function(token) {
            if (token) {
                $('form').each(function() {
                    $(this).find('input.recaptcha_token').remove();
                    $(this).append('<input type="hidden" name="recaptcha_token" class="recaptcha_token" value="' + token + '">');
                    $(this).find(':input[type="submit"]').not('.manual-disabled').prop('disabled', false).removeClass('disabled');
                });

                console.log(' +reCAPTCHA Enabled');
                //$('#recaptcha_token, .recaptcha_token').val(token);
            }
        });
    }
}
